import { Sms, VpnLock } from '@mui/icons-material'
import { DialogContent, DialogContentText, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ConfirmDialogActions from '@/components/feedback/ConfirmDialogActions'
import CustomDialog from '@/components/feedback/CustomDialog'
import { ControllerRestartMethod } from '@/features/controller/restart/types'

interface RestartConfirmDialogProps {
  open: boolean
  selectedMethod: ControllerRestartMethod
  isPending: boolean
  onMethodChange: (method: ControllerRestartMethod) => void
  onConfirm: () => void
  onCancel: () => void
}

export function RestartConfirmDialog({
  open,
  selectedMethod,
  isPending,
  onMethodChange,
  onConfirm,
  onCancel,
}: RestartConfirmDialogProps) {
  const { t } = useTranslation()

  const RESTART_METHOD_OPTIONS = [
    { value: ControllerRestartMethod.SSH, label: t('controllers.restart_dialog.method_ssh'), icon: <VpnLock /> },
    { value: ControllerRestartMethod.SMS, label: t('controllers.restart_dialog.method_sms'), icon: <Sms /> },
  ]

  return (
    <CustomDialog open={open} size="extraSmall" title={t('controllers.restart_dialog.title')} onClose={onCancel}>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{t('controllers.restart_dialog.confirm_message')}</DialogContentText>
        <RadioGroup value={selectedMethod} onChange={(e) => onMethodChange(e.target.value as ControllerRestartMethod)}>
          {RESTART_METHOD_OPTIONS.map((option) => (
            <FormControlLabel key={option.value} control={<Radio />} label={option.label} value={option.value} />
          ))}
        </RadioGroup>
      </DialogContent>
      <ConfirmDialogActions disabled={isPending} onCancel={onCancel} onConfirm={onConfirm} />
    </CustomDialog>
  )
}
